import styled from 'styled-components'
import { border, boxModel, css } from '../util'
import { borderTypes, boxModelTypes, cssTypes } from '../types'

/**
 * @namespace Table
 * @desc Primitive styled-component 💅
 * @return {Function} React component
 */
const Table = styled.table`
  border-collapse: ${({ borderCollapse }) => borderCollapse};
  ${border};
  ${boxModel};
  ${css};
  table-layout: ${({ tableLayout }) => tableLayout};
`

/**
 * @name defaultProps
 * @memberof Table
 * @desc Primitive's default properties
 */
Table.defaultProps = {
  borderCollapse: 'collapse',
  borderWidth: [0],
  margin: [0],
  padding: [0],
  size: ['auto'],
  tableLayout: 'fixed',
}

/**
 * @name propTypes
 * @memberof Table
 * @desc Primitive's prop type definitions
 */
Table.propTypes = {
  ...borderTypes,
  ...boxModelTypes,
  ...cssTypes,
}

/** @component */
export default Table
